interface Options {
  body?: object;
  headers?: object;
}

interface ConfigProps extends RequestInit {
  method?: string;
  body?: string;
  headers?: HeadersInit;
}

export const fetchWrapper = (url: string, { body, headers, ...customConfig }: Options = {}) => {
  const customHeaders = {
    'Content-Type': 'application/json',
    ...headers,
  };

  const config: ConfigProps = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: customHeaders,
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  return window.fetch(url, config).then(async (response) => {
    const data = await response.json();
    if (response.ok) {
      return data;
    } else {
      return Promise.reject(data);
    }
  });
};
